import Painel from "../pages/painel";
import { RootRedirect } from "./redirects";
export var Routes = {
    "/": RootRedirect,
    "/painel": RootRedirect,
    "/meus-graficos": Painel,
    "/disque100/:subaba": Painel,
    "/mulheres/:subaba": Painel,
    "/lgbtqia/:subaba": Painel,
};
